var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 37,
    viewBox: "0 0 31 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57178 1.70459L8.70549 2.50684C9.03976 4.51246 9.24032 5.51526 9.90885 6.11695C10.6442 6.71863 11.6471 6.71863 13.6527 6.71863H16.8617C18.9341 6.71863 19.9369 6.71863 20.6055 6.11695C21.3409 5.51526 21.4746 4.51246 21.8088 2.50684L21.9425 1.70459M8.57178 24.1675H15.324M8.57178 15.6771H22.0763",
    stroke: "#F59B1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.01758 14.0056C1.01758 8.12248 1.01757 5.1809 2.75577 3.37584C4.49397 1.57079 7.23498 1.5708 12.8507 1.5708H17.9316C23.4805 1.5708 26.2883 1.57079 28.0265 3.37584C29.7647 5.1809 29.7647 8.12248 29.7647 14.0056V22.8972C29.7647 28.7803 29.7647 31.7219 28.0265 33.5269C26.2883 35.332 23.5473 35.332 17.9316 35.332H12.8507C7.30184 35.332 4.49397 35.332 2.75577 33.5269C1.01757 31.7219 1.01758 28.7803 1.01758 22.8972V14.0056Z",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTablet);
export default __webpack_public_path__ + "static/media/icon_tablet.ff71aa5f208f605e0d98e8e297094e81.svg";
export { ForwardRef as ReactComponent };